import React, { useState, useEffect } from "react";
import axios from "axios";
import swal from "sweetalert";
import InputField from "../inputComponents/InputField";
import Message from "../inputComponents/Message";
import Loading from "../../childComponents/appComponents/Loading";

const ModalRead = (props) => {
  const BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const FRONTEND_URL = process.env.REACT_APP_FRONTEND_URL;
  const ADMINNAME = localStorage.getItem("auth_name");
  const today = new Date().toISOString().split("T")[0];
  
  const BUTTON_NAME = "POST CONTENT"; // Submit Button Name
  //Fetches all Form
  const [message, setMessage] = useState("");
  const [actionType, setActionType] = useState("");
  const [disabled, setDisabled] = useState(null);
  const [readOnly, setReadOnly] = useState(false);
  const [allformData, setAllFormData] = useState({
    //trackId, email, names, status, mobile, address, textMessage, subject, createdTime,
    input: {
      trackId: null,
      email: "publish",
      names: today,
      status: null,
      mobile: null,
      address: null,
      subject: null,
      createdTime: null,
    },
    select: {},
  });

  const [returnUpload, setReturnUpload] = useState("");

  const [options, setOptions] = useState({
    // width01: [
    //   { values: "auto", item: "Default" },
    //   { values: "10", item: "10%" },
    //   { values: "20", item: "20%" },
    //   { values: "30", item: "30%" },
    //   { values: "40", item: "40%" },
    //   { values: "50", item: "50%" },
    //   { values: "60", item: "60%" },
    //   { values: "70", item: "70%" },
    //   { values: "80", item: "80%" },
    //   { values: "90", item: "90%" },
    //   { values: "100", item: "100%" },
    // ],
    // getPageLink: [],
  });
const [reloadState, setReloadState] = useState({
            btnLoading: props.modalTitle,
            loading: true,
          });
  function extractColumn(arr, column, value) {
    return arr.map((x) => ({
      values: x[value],
      item: x[column],
    }));
  }

  // Function to update form data dynamically
  const updateFormData = (type, key, value) => {
    setAllFormData((prev) => ({
      ...prev,
      [type]: {
        ...prev[type],
        [key]: value,
      },
    }));
  };

  //replaces each first character of a word with its uppercase version
  function ucwords(str = "") {
    return str.replace(/\b\w/g, (char) => char.toUpperCase());
  }

  useEffect(() => {
    if (!props.editposts) return;

    const isEdit = props.editposts.id;
    const titeles = props.modalTitle;

    // ✅ EDIT MODE (load DB values)
    if (isEdit && titeles === "READ MAIL") {
      setDisabled("disabled");
      setReadOnly(true);

      const query = `?trackId[eq]=${props.editposts.trackId}`;
      markAsRead(query); // pass value directly to mark the as read

      setMessage(props.editposts.textMessage || "");
      setAllFormData((prev) => ({
        ...prev,
        input: {
          trackId: props.editposts.trackId || "",
          email: props.editposts.email || "",
          names: props.editposts.names || "",
          status: props.editposts.status || "",
          mobile: props.editposts.mobile || "",
          address: props.editposts.address || "",
          subject: props.editposts.subject || "",
          createdTime:
            props.editposts.createdTime || today
              ? new Date(props.editposts.createdTime * 1000)
                  .toISOString()
                  .split("T")[0]
              : "",
        },
        select: {},
      }));
    } else if (isEdit && titeles === "REPLY MAIL") {
      setDisabled("disabled");
      setReadOnly(false);

      setMessage("");
      setAllFormData((prev) => ({
        ...prev,
        input: {
          trackId: props.editposts.trackId || "",
          email: props.editposts.email || "",
          names: props.editposts.names || "",
          status: props.editposts.status || "",
          mobile: props.editposts.mobile || "",
          address: props.editposts.address || "",
          subject: "Re: " + props.editposts.subject || "",
          createdTime: today,
        },
        select: {},
      }));
    }
    // ✅ ADD MODE (use defaults)
    else {
      setDisabled(null);
      setReadOnly(false);
      setMessage("");

      const today = new Date().toISOString().split("T")[0];
      setAllFormData({
        input: {
          trackId: "",
          email: "",
          names: "",
          status: "",
          mobile: "",
          address: "",
          subject: "",
          createdTime: today,
        },
        select: {},
      });
    }
setReloadState((prev) => ({
      ...prev,
      btnLoading: props.modalTitle,
      loading: false,
    }));
    
  }, [props.editposts, props.modalTitle]);

  const markAsRead = async (query) => {
    try {
      await axios.get("sanctum/csrf-cookie");

      const responses = await Promise.all([
        axios.get(`${BASE_URL}fbdataread${query}`),
      ]);

      const [fbdataAll] = responses;

      if (fbdataAll?.data?.status === 200) {
        if (fbdataAll.data.allData.length === 0) {
          swal(
            "Oops!",
            "Sorry! we did not find any information in the Inbox Mail",
            "warning",
          );
        } else {
          props.reloadCharts();
          //setAllRecords(fbdataAll.data.allData);
        }
      }
    } catch (error) {
      //swal("Error", "Error fetching Registry Data", "error");
      console.log("Error fetching Registry Data:", error);
    }
  };

  async function submitUpload(event) {
    event.preventDefault();
    setReloadState((prev) => ({
      ...prev,
      btnLoading: <div>Processsing...</div>,
      loading: true,
    }));

    let urlpost;

    //READ MAIL, REPLY MAIL, POST MAIL
    urlpost = `${BASE_URL}fbdataresponce`;

    let formData;

    formData = new FormData();

    if (actionType === "POST MAIL") {
      formData.append("action", "POSTMAIL");
    } else if (actionType === "REPLY MAIL") {
      formData.append("action", "REPLYMAIL");
    } else if (actionType === "READ MAIL") {
      formData.append("action", "READMAIL");
    } else {
      formData.append("action", "TRASH");
    }

    formData.append("trackId", allformData.input.trackId);
    formData.append("email", allformData.input.email);
    formData.append("names", allformData.input.names);
    formData.append("status", allformData.input.status);

    formData.append("mobile", allformData.input.mobile);
    formData.append("address", allformData.input.address);

    formData.append("subject", allformData.input.subject);
    formData.append("createdTime", allformData.input.createdTime);

    formData.append("textMessage", message);

    formData.append("id", props.editposts.id);

    await axios.get(`sanctum/csrf-cookie`).then((response) => {
      try {
        axios.post(urlpost, formData).then((res) => {
          if (res?.data?.status === 200) {
            swal("Success", res.data.message, "success");
            setReloadState({
              btnLoading: props.modalTitle,
              loading: false,
            });
            props.formCleanners();
            props.setCloseModal(true);
          } else {
            swal("Oops!", res.data.message, "error");
          }
        });
      } catch (error) {
        swal("Oops!", "Failed", "error");
        console.log(error.response.data);
      }
    });
  }
if (reloadState.loading) {
    return <Loading message01={"Loading..."} />;
  }
  return (
    <>
      <form onSubmit={submitUpload} encType="multipart/form-data">
        <div className="row">
          <div className="col-md-12 mb-3">
            <div className="card">
              <div
                className={`card-header text-white bg-${props.btnColors} p-3`}
              >
                <i className="fa fa-newspaper"></i> {props.modalTitle}
              </div>

              <div className="card-body">
                <div className="row m-1">
                  {props.modalTitle !== "POST MAIL" ? (
                    <>
                      <InputField
                        label="Track ID"
                        name="trackId"
                        size="6"
                        disabled={disabled}
                        placeholder="Please Insert Track ID"
                        required=""
                        value={allformData.input.trackId}
                        type="text"
                        onChange={updateFormData}
                        icon="fa fa-barcode"
                      />

                      <InputField
                        label="Names"
                        name="names"
                        size="6"
                        disabled={disabled}
                        placeholder="Please Insert Senders Names"
                        required="required"
                        value={allformData.input.names}
                        type="text"
                        onChange={updateFormData}
                        icon="fa fa-user"
                      />

                      <InputField
                        label="Phone Number"
                        name="mobile"
                        size="6"
                        disabled={disabled}
                        placeholder="Please Insert Senders Phone Number"
                        required=""
                        value={allformData.input.mobile}
                        type="text"
                        onChange={updateFormData}
                        icon="fa fa-phone"
                      />
                    </>
                  ) : (
                    ""
                  )}

                  <InputField
                    label="Email"
                    name="email"
                    size="6"
                    disabled={disabled}
                    placeholder="Email To"
                    required="required"
                    value={allformData.input.email}
                    type="text"
                    onChange={updateFormData}
                    icon="fa fa-envelope"
                  />

                  <InputField
                    label="Date"
                    name="createdTime"
                    size="6"
                    disabled={disabled}
                    placeholder="Please Select  Date"
                    required="required"
                    value={allformData.input.createdTime}
                    type="date"
                    onChange={updateFormData}
                    icon="fa fa-calendar-check-o"
                  />

                  {props.editposts.status === "trash" ? (
                    <>
                      <div className="col-lg-6 p-4 row">
                        <InputField
                          label="Read"
                          size="6"
                          name="status"
                          type="radio"
                          checked={allformData.input.status === "read"}
                          value="read"
                          onChange={updateFormData}
                        />

                        <InputField
                          label="Unread"
                          size="6"
                          name="status"
                          type="radio"
                          checked={allformData.input.status === "pending"}
                          value="pending"
                          onChange={updateFormData}
                        />
                      </div>

                      <div className="col-lg-6 ps-4">
                        <div className="form-group mt-2">
                          <button
                            type="submit"
                            className={`btn btn-${props.btnColors} col-lg-12 mt-4`}
                            onClick={() => setActionType("TRASH")}
                          >
                            <div className="d-flex align-items-center justify-content-center w-100">
                              <i className="fa fa-edit m-1"></i>
                              <span>Mark Mail</span>
                            </div>
                          </button>
                        </div>
                      </div>
                    </>
                  ) : (
                    ""
                  )}
                </div>
              </div>

              <div className="card-body">
                <InputField
                  label="Subject"
                  name="subject"
                  size="12"
                  disabled={disabled}
                  placeholder="Please Insert a Subject"
                  required="required"
                  value={allformData.input.subject}
                  type="text"
                  onChange={updateFormData}
                  icon="fa fa-columns"
                />

                <Message
                  titles="Message"
                  nameId="message"
                  placeholder="Publication/ Description"
                  size="12"
                  inputState=""
                  moreDetail={message}
                  setMessage={setMessage}
                  readOnly={readOnly}
                />
                {readOnly === false ? (
                  <div className="row m-1">
                    <div className="col-lg-12 ps-4">
                      <div className="form-group mt-2">
                        <button
                          type="submit"
                          className={`btn btn-${props.btnColors} col-lg-12 mt-4`}
                          onClick={() => setActionType(props.modalTitle)}
                        >
                          <div className="d-flex align-items-center justify-content-center w-100">
                            <i className="fa fa-edit m-1"></i>
                            <span>{reloadState.btnLoading}</span>
                          </div>
                        </button>
                      </div>
                    </div>
                  </div>
                ) : null}
              </div>
            </div>
          </div>
        </div>
      </form>
    </>
  );
};
export default ModalRead;
